/*
A simple 'show more' function for our checkbox filters
*/

export function showMore(event) {

    const siblings = event.target.parentElement.children;

    for (let i = 8; i < siblings.length; i++) {

        siblings[i].classList.toggle('hidden');

    }

}
